import ImagePlaceholder from "@/images/navbar_logged_out_profile_icon.svg";
import clsxm from "@/lib/clsxm";
import {memo, type FC} from "react";

const InfluencerMiniProfile: FC<{
  className?: string;
  id: number;
  image?: string | null;
  firstName?: string;
  textContainerClassName?: string;
  username?: string | null;
  usernameClassName?: string;
}> = ({className, id, image, firstName, textContainerClassName, username, usernameClassName}) => (
  <div
    onClick={e => {
      e.stopPropagation();
      window.open(`/influencer/${id}/`, "_blank");
    }}
    className={clsxm("z-10 flex cursor-pointer items-center gap-2", className)}>
    <img src={image ?? ImagePlaceholder} className="size-7 shrink-0 rounded-full" />
    <div className={clsxm("text-neutral-black", textContainerClassName)}>
      <span className="block text-sm font-semibold">{firstName}</span>
      <span className={clsxm("-mt-1 block text-[10px]", usernameClassName)}>{username}</span>
    </div>
  </div>
);

export default memo(InfluencerMiniProfile);
